import { db } from "./firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

const getPayments = async (user_uuid: string) => {
  console.log(user_uuid);

  const q = query(
    collection(db, `payments`),
    where("userUUID", "==", user_uuid)
  );

  const data: any = [];

  const querySnapshot = await getDocs(q);

  if (querySnapshot) {
    querySnapshot.forEach((doc) => {
      data.push(doc.data());
    });
  }

  const normalizeTimestamp = (timestamp: number) => {
    return timestamp < 1000000000000 ? timestamp * 1000 : timestamp;
  };

  data.sort(
    (a: any, b: any) =>
      normalizeTimestamp(b.createdAt) - normalizeTimestamp(a.createdAt)
  );

  return data;
};

export { getPayments };
